import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const InputAttentionMessage = ({ message }) => {
  const classes = useStyles();
  return (
    <p className={classes.inputAttentionMessage}>{message}</p>
  );
};

InputAttentionMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default InputAttentionMessage;
